import { format } from "date-fns";
import api from "../services/api";

interface IConferencesAgentResponse {
    codeResult: string;
    data: any[];
}

export interface IConferencesAgentParams {
    year: string;
    month: string;
    agentId: string;    

}
export interface IConferencesAgent {
    numero: number;
    revendedor: string;
    cidade: number;
    valorVendido: number;
    valorReceber: number;
    valorRecebido: number;
}


class ConferencesKitAgentRepository {
    public async Conferences({ year, month, agentId }: IConferencesAgentParams): Promise<IConferencesAgent[]> {
        const initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(parseInt(year), parseInt(month), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Revendedor", "Conference", "Kit"],
            "sql": [
                {
                    "coderesult": "Conferences",
                    "query": `SELECT Kit.numero as Numero, Revendedor.nome as Nome, Revendedor.cidade as Cidade, 
                    Conference.valorVendido as ValorVendido, 
                    Conference.valorReceber as ValorReceber,
                    Conference.valorRecebido as ValorRecebido
                    FROM Kit 
                    LEFT JOIN Revendedor 
                    ON Revendedor.id = Kit.revendedorId 
                    INNER JOIN Conference 
                    ON Conference.kitId = Kit.id 
                    WHERE Conference.conferenceType = 0
                    AND Conference.data >= '${initialDate}' 
                    AND Conference.data < '${endDate}' 
                    AND Conference.representanteId = '${agentId}'
                    ORDER BY Conference.valorVendido DESC`
                }
            ]
        };

        const response = await api.post<IConferencesAgentResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "Conferences").map(result => {
            return {
                numero: result.Numero,
                revendedor: result.Nome,
                cidade: result.Cidade,
                valorVendido: result.ValorVendido,
                valorReceber: result.ValorReceber,
                valorRecebido: result.ValorRecebido
            }
        });
    }

    GetFromCodeResult(data: IConferencesAgentResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const conferencesKitAgentRepository = new ConferencesKitAgentRepository();
export default conferencesKitAgentRepository;